var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex align-items-center mb-4"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    attrs: {
      "variant": "primary",
      "title": "Selecionar lista de preços de serviços"
    },
    on: {
      "click": _vm.abrirModal
    }
  }, [_c('TagOutline', {
    staticClass: "mr-1",
    attrs: {
      "size": 20
    }
  }), _vm._v(" " + _vm._s(_vm.buttonLabel) + " ")], 1), _vm.value && _vm.value.descricao ? _c('span', {
    staticClass: "badge badge-light px-3 py-2 ml-3"
  }, [_c('strong', [_vm._v("Lista selecionada:")]), _vm._v(" " + _vm._s(_vm.value.descricao) + " "), _c('button', {
    staticClass: "btn btn-link text-danger p-0 ml-2",
    attrs: {
      "type": "button",
      "title": "Remover lista selecionada"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('input', null);
      }
    }
  }, [_c('CloseCircleOutline', {
    attrs: {
      "size": 18
    }
  })], 1)]) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "modal-lista-preco-servico",
      "title": "Selecionar lista de preços de serviços",
      "hide-footer": ""
    },
    on: {
      "shown": function shown($event) {
        return _vm.carregarListas('');
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Lista de preços"
    }
  }, [_c('VueSelect', {
    attrs: {
      "filterable": false,
      "options": _vm.listas,
      "value": _vm.value
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event);
      },
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.descricao) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.descricao) + " ")];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Nenhuma lista de preços encontrada ")])], 2)], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-lista-preco-servico');
      }
    }
  }, [_vm._v(" Aplicar ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };